// List of countries blocked from receiving shipments due to EU regulations and international sanctions
export const blockedCountries = [
    // Countries under EU sanctions/restrictions
    'RU', // Russia
    'BY', // Belarus
    'IR', // Iran
    'SY', // Syria
    'VE', // Venezuela
    'KP', // North Korea
    'CU', // Cuba
    'AF', // Afghanistan
    
    // Conflict zones or areas with severe restrictions
    'SD', // Sudan
    'SS', // South Sudan
    'YE', // Yemen
    'MM', // Myanmar/Burma
    
    // Crimea, Donetsk, and Luhansk regions (though technically part of Ukraine, need special handling)
    // These would need additional address validation as they can't be identified by country code alone
];

export const isCountryBlocked = (countryCode: string): boolean => {
    return blockedCountries.includes(countryCode.toUpperCase());
};

export const getBlockedCountryMessage = (countryCode: string): string => {
    return `Due to EU regulations and international sanctions, we cannot ship to ${countryCode}. If you believe this is an error, please contact our support team.`;
};
